export default "﻿<h1>Void</h1>"